module.exports = __webpack_public_path__ + "static/img/6.815afec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/6.png
// module id = 2csz
// module chunks = 0